module.exports = __webpack_public_path__ + "img/two-step-auth.ff0bdf80.svg";